<template>
  <form v-on:submit.prevent="doFilter()" class="form-search">
    <label for="search" class="sr-only">Recherche</label>
    <input
      type="text"
      class="form-control input-search"
      v-model="search"
      :placeholder="data.title"
    />

    <button type="submit" class="btn-search">
      <span class="sr-only">Recherche</span>
      <i
        v-on:click="clearSearch()"
        class="fa fa-times fa-xs"
        aria-hidden="true"
        style="color:gray; margin-right:5px;"
      ></i>
      <i class="fa fa-search" aria-hidden="true"></i>
    </button>
  </form>
</template>

<script>
export default {
  name: "volcan-filter-bar",
  props: ["data"],
  data() {
    return {
      search: ""
    };
  },
  methods: {
    doFilter() {
      this.data.filter = this.search;
    },
    clearSearch() {
      this.search = "";
      this.data.filter = "";
    }
  }
};
</script>

<style scoped>
.input-search {
  padding: 5px 40px 5px 10px;
}

.form-search {
  position: relative;
}

.btn-search {
  cursor: pointer;
  position: absolute;
  top: 0;
  right: 0;
  background: none;
  border: none;
  padding: 9px 10px;
  font-size: 20px;
  line-height: 1;
}
</style>



// WEBPACK FOOTER //
// components/AdminTools/dataTable/filterBar.vue